import React, { Component } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { BiMessageDetail } from "react-icons/bi";
import { BsPhone } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import Image from "../micro/Image";

class ConnectionsModal extends Component {
  render() {
    let telegramNumber = "+989" + this.props?.phone?.split("09")[1];

    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="999999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom w-auto rounded-top-14"
          isOpen={this.props.connectionsModal}
          toggle={() =>
            this.props.connectionsModalChange(!this.props.connectionsModal)
          }
        >
          <ModalBody className="p-3">
            {this.props.withoutOnlineOrdering && (
              <div className="text-center">
                <Image
                  imageHeight={"45"}
                  imageWidth={"45"}
                  extraClassName={"p-0 img-contain"}
                  imgClassName={"rounded-circle img-cover"}
                  isProfile={true}
                  imageUri={this.props?.shop?.conver?.thumbnail}
                />
                <div className="fw-bolder mt-3 fs-6 d-flex justify-content-center">
                  {this.props?.shop?.title}
                  {this.props?.shop?.is_verify && (
                    <img
                      width="15"
                      className="me-1"
                      alt="verify"
                      src={
                        require("../../../base/assets/icons/verify.svg").default
                      }
                    />
                  )}
                </div>
                <div className="text-gray mt-2 fs-7">
                  {this.props?.shop?.sub_title}
                </div>
              </div>
            )}
            <div className="p-3 btn fs-5 d-block text-end">
              <a href={`tel:${this.props.phone}`}>
                <BsPhone />
                <span className="me-2 fs-6">تماس</span>
              </a>
            </div>
            <div className="p-3 btn fs-5 d-block text-end">
              <a href={`sms:/*${this.props.phone}`}>
                <BiMessageDetail />
                <span className="me-2 fs-6">ارسال پیام</span>
              </a>
            </div>
            {this.props.phone && (
              <div className="p-2 btn fs-5 d-block text-end">
                <a href={`https://t.me/${telegramNumber}`}>
                  <img
                    width="25"
                    className="me-1"
                    alt="telegram"
                    src={
                      require("../../../base/assets/icons/telegram.svg").default
                    }
                  />
                  <span className="me-2 fs-6">تلگرام</span>
                </a>
              </div>
            )}
            <div className="p-3 btn fs-5 d-block text-end">
              <a href={`https://wa.me/+98${this.props.phone.substring(1)}`}>
                <FaWhatsapp />
                <span className="me-2 fs-6">واتساپ</span>
              </a>
            </div>
            <div className="d-block">
              <CopyToClipboard
                text={this.props.phone}
                onCopy={() => {
                  Swal.fire({
                    text: "کپی شد",
                    icon: "success",
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.props.connectionsModalChange(false);
                }}
              >
                <div className="p-3 btn fs-5">
                  <MdContentCopy />
                  <span className="me-2 fs-6">کپی</span>
                </div>
              </CopyToClipboard>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ConnectionsModal;
